<template>
  <div v-if="!is_loading">
    <h1>Calendar</h1>
    <div v-if="is_premium">
      <p>Need some help navigating our platform?<br />Book a slot here and I will guide you through!</p>
      <iframe width="100%" style="border:0;max-width:1200px;height:700px" height="700" border="0" frameborder="0" src="https://calendly.com/d/cmk9-gzb-rj5/platform-call-with-proptecham-ai"></iframe>
      <!--
       <iframe width="100%" style="border:0;max-width:1200px;height:700px" height="700" border="0" frameborder="0" src="https://calendly.com/miguel-sanchis/30min?hide_gdpr_banner=1&text_color=20365f&primary_color=34a7c2"></iframe>
      <iframe width="100%" style="border:0;max-width:1200px;height:700px" height="700" border="0" frameborder="0" src="https://calendly.com/proptecham/introduction?hide_gdpr_banner=1&text_color=20365f&primary_color=34a7c2"></iframe> -->
      <!-- <iframe width="100%" style="border:0;max-width:1200px;height:700px" height="700" border="0" frameborder="0" src="https://calendly.com/proptech-intro/platform-demo/30min?hide_gdpr_banner=1&text_color=20365f&primary_color=34a7c2"></iframe> --->
    </div>
    <div v-else>
      <p>In order to become a premium client and raise capital, we would like to have an introductory call with you. <br />Please select a suitable time slot in our calendar to book a call with us!</p>
      <iframe width="100%" style="border:0;max-width:1200px;height:700px" height="700" border="0" frameborder="0" src="https://calendly.com/d/cmk9-gzb-rj5/platform-call-with-proptecham-ai"></iframe>
      <!-- <iframe width="100%" style="border:0;max-width:1200px;height:700px" height="700" border="0" frameborder="0" src="https://calendly.com/d/4dt-7ct-5x9/introduction-call-with-proptecham-ai?hide_gdpr_banner=1&text_color=20365f&primary_color=34a7c2"></iframe>
    <iframe width="100%" style="border:0;max-width:1200px;height:700px" height="700" border="0" frameborder="0" src="https://calendly.com/proptecham/introduction?hide_gdpr_banner=1&text_color=20365f&primary_color=34a7c2"></iframe> -->
    <!--  <iframe width="100%" style="border:0;max-width:1200px;height:700px" height="700" border="0" frameborder="0" src="https://calendly.com/proptech-intro/45min?hide_gdpr_banner=1&text_color=20365f&primary_color=34a7c2"></iframe> -->
    </div>

    <!-- Calendly inline widget begin - ->
    <div class="calendly-inline-widget" data-url="https://calendly.com/miguel-sanchis/30min?hide_gdpr_banner=1" style="min-width:320px;height:700px;"></div>
    <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
    <! -- Calendly inline widget end -->
  </div>
</template>
<script>
export default {
  components: {},
  mounted(){

this.getQuestionnaire();

  },
  methods: {
    getQuestionnaire(){
      axios.get('/api/user/profile/questionnaire')
          .then(response => response.data)
          .then(response => {
            this.is_loading = false;
            this.is_premium = response.user.profile.is_premium;
           })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },

  },
  data() {
    return {
      is_premium: false,
      is_loading: true,
    }
  },
  computed: {
  },
  filters: {
  },
}
</script>